import React from 'react';
import { useRouter } from 'next/router';
import { BsFillCheckCircleFill } from 'react-icons/bs';

import { SiteContext } from '@/contexts/site-context';
import FormSteps from '@/components/FormSteps';
import { CATEGORY_SUBSETS } from '@/contexts/categories_subset';

const CategorySelect = () => {
  const [site, setSite] = React.useContext(SiteContext);

  const [error, setError] = React.useState(false);
  const [selectedCategory, setSelectedCategory] = React.useState(null);

  const [isReady, setIsReady] = React.useState(false);

  const router = useRouter();

  const handleSelect = (category) => {
    setError(false);

    if (category === 'Other') {
      // Special case... skip to end.
      setSelectedCategory({
        id: 'Other'
      });
      // setTimeout(() => {
      //   router.push('/signup/other')
      // }, 250)
    } else {
      setSelectedCategory(category);

      setSite({
        ...site,
        business_sign_up: {
          ...site.business_sign_up,
          category: { ...category }
        }
      });

      // // User MUST redo budget if category has been changed.
      // setTimeout( () => {
      //   router.push('/signup/geo')
      // }, 250)
    }
  };

  const validate = () => {
    if (!selectedCategory) {
      setError(true);
    } else {
      if (selectedCategory === 'Other') {
        // Special case... skip to end.
        setSelectedCategory({
          id: 'Other'
        });
        setTimeout(() => {
          router.push('/signup/other');
        }, 250);
      } else {
        // User MUST redo budget if category has been changed.
        setTimeout(() => {
          router.push('/signup/geo');
        }, 250);
      }
    }
  };

  React.useEffect(() => {
    // If the user hasn't finished the first step, send them back.
    if (!site.business_sign_up?.business_name) {
      router.push('/signup/business-info');
    } else {
      setIsReady(true);
      setSelectedCategory(site.business_sign_up.category);
    }
  }, [site.business_sign_up.category]);

  return (
    <div className="signup-form-container">
      {isReady && (
        <div className="signup-form-wrapper">
          <FormSteps stepIndex={1} totalSteps={6} />
          <fieldset className="panel-content">
            <h2>Category Information</h2>
            <h3>Select the category you wish to receive calls for. You can only select one category. You can add more later once you&apos;ve signed up.</h3>
            <div className="row">
              <div className={`input-container radio-container ${error ? 'error' : ''}`}>
                {CATEGORY_SUBSETS.filter((category) => !category.exclude_from_popular_categories).map((category) => (
                  <button key={category.id} className={`radio button ${selectedCategory?.id === category.id ? 'selected' : ''}`} onClick={() => handleSelect(category)}>
                    {selectedCategory?.id === category.id && <BsFillCheckCircleFill />}
                    {category.name}
                  </button>
                ))}
                <button className={`radio button ${selectedCategory?.id === 'Other' ? 'selected' : ''}`} onClick={() => handleSelect('Other')}>
                  {selectedCategory?.id === 'Other' && <BsFillCheckCircleFill />}
                  Other
                </button>
              </div>
            </div>
            <div className="error_msg">{error ? 'Please select a service category.' : <span>&nbsp;</span>}</div>
            <div className="row next-container">
              <div className="actions">
                <button className="next button" onClick={validate}>
                  Next
                </button>
              </div>
            </div>
          </fieldset>
        </div>
      )}
    </div>
  );
};

export default CategorySelect;
